module.exports = __webpack_public_path__ + "animoji7.e0da6422a7.png";